import gql from 'graphql-tag';
import { ADDRESS_FRAGMENT, RestAddressData } from '../fragments.rest';

export type EditAddressMutation = {
  editAddress: {
    __typename: 'RestAddress';
    data: RestAddressData;
  };
};

export const EDIT_ADDRESS_MUTATION = gql`
  mutation EditAddressMutation($id: Int!, $input: AddressQueryVariables) {
    editAddress(id: $id, input: $input)
    @rest(type: "RestAddress", endpoint: "user", path: "/addresses/{args.id}", method: "PATCH") {
      data @type(name: "RestAddressData") {
        ...AddressFragment
      }
    }
  }
  ${ADDRESS_FRAGMENT}
`;
